import { render, staticRenderFns } from "./TicketViewSwitchCompany.vue?vue&type=template&id=73335ada&scoped=true"
import script from "./TicketViewSwitchCompany.vue?vue&type=script&lang=js"
export * from "./TicketViewSwitchCompany.vue?vue&type=script&lang=js"
import style0 from "./TicketViewSwitchCompany.vue?vue&type=style&index=0&id=73335ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73335ada",
  null
  
)

export default component.exports